import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useNavigate, useLocation } from "react-router-dom";
import { Checkbox, Button, Modal, Spin } from "antd";
import { toast } from "react-toastify";
import userServiceApi from "../../api/userServiceApi";
import { getRequest } from "../../api/http";
import "./Login.scss";
import TermsViewer from "./termsViewer";
import { EXISTING_MEMBER_QUESTIONS } from "../constants";

export default function TermsForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [loading, setLoading] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
 const [deniedModal] = useState(false);
  const [partnerData, setPartnerData] = useState({});
  const partnerName = localStorage.getItem("partner");
  const partnerID = localStorage.getItem("partnerID");
  const [reviewModalVisible, setReviewModalVisible] = useState(false);

  const [submitBtnStatus, SetSubmitBtnStatus] = useState(true);

  const handleCancel = () => {
    setReviewModalVisible(false);
  };

  const handleChange = (e) => {
    SetSubmitBtnStatus(!e.target.checked);
  };


  const HideModal = () => {
    setIsModalOpen(false);
  };

  const submitHandler = async () => {
    let submit = {
      userName: state?.formData?.userName,
      email: state?.formData?.email,
      phone: state?.formData?.phone,
      partnerName: partnerName,
      isActiveMember: state?.formData?.isActiveMember,
      name: state?.formData?.name,
      websiteLink: state?.formData?.websiteLink,
      typeId: state?.formData?.typeId,
      size: state?.formData?.size,
      addressInputs: [
        {
          street: state?.formData?.addressStreet,
          postalCode: state?.formData?.postcode,
        },
      ],
    };

    try {
      setLoading(true);

      const response = await fetch(userServiceApi.createOrganizationUser(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submit),
      });

      const data = await response.json();

      // ✅ Success case
      if (response.status === 200) {
        toast.success("Organisation added successfully");
        navigate("/");
      }
      // ✅ Bad request (400)
      else if (response.status === 400) {
        // Try regex match first
        const match = data.message?.match(/\{"errors":\[.*\]\}/);

        if (match) {
          const parsed = JSON.parse(match[0]);
          if (
            parsed.errors &&
            Array.isArray(parsed.errors) &&
            parsed.errors.length > 0
          ) {
            toast.error(parsed.errors[0].message);
          }
        } else if (data?.errorLog || data.error) {
          // Fallback: show "error" field if regex didn’t match
          toast.error(data.message || data.error);
        } else {
          toast.error(
            `${data.message || "Invalid request. Please check your details and try again."}`
          );
        }
      }
      // ✅ Other errors
      else if (!response.ok) {
        toast.error(`Unexpected error: ${response.status}`);
      }
    } catch (error) {
      console.error("Submit failed:", error);
      toast.error("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };


  const getPartnerDetailsData = async (partnerID) => {
    try {
      // setLoading(true);
      const response = await getRequest(
        // userServiceApi.getPartnerDetailsLoginScreen(partnerID)
        userServiceApi.getPartnerDetailsLoginScreen(partnerName)

      );
      if (response && response.data) {
        setPartnerData(response.data);
      }
      setLoading(true);
    } catch (error) {
      setLoading(false);
      toast.error(error.error);
    }
  };

  const redirectHandler = () => {
    sessionStorage.clear();
    if (isMobile) {
      setAlertModal(true);
    } else {
      navigate(`/login/${partnerID}`);
    }
  };

  useEffect(() => {
    getPartnerDetailsData(partnerID);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className="headerBannerRow">
        <div className="headerBannerCol">
          <div className="container">
            <img
              className="signup-logo"
              style={{ cursor: "pointer" }}
              src={partnerData.mediaLink}
              alt=""
              onClick={redirectHandler}
            />
            {/* <label>{partnerData.siteName}</label> */}
            <h3 className="signUpHeading">
              Add your organisation to {partnerData.siteName}
            </h3>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="tabContainer">
          <div className="terms-container">
            <div className="termsHeading">
              <h2>Terms and conditions</h2>
            </div>
            <div className="terms-text">
              <div className="terms-content" style={{
                height:'100%'
              }}> 
                {/* <iframe
                  src={`${termsAndConditions}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                  width="100%"
                  height="100%"
                  style={{ border: "none", borderRadius: "12px", padding:'12px' }}
                  title="Terms and Conditions"
                /> */}
                <TermsViewer />
                {/* <br></br>
                (Note: This is a generic sample and should be tailored to your
                specific needs. Consult with a legal professional to ensure
                accuracy and compliance with relevant laws.) */}
              </div>
            </div>
            <div className="check-submit">
              <div className="checkbox">
                <Checkbox onChange={handleChange}>
                  Accept the terms and conditions
                </Checkbox>
              </div>
            </div>
            <div className="submitbtn">
              <Button
                disabled={submitBtnStatus}
                className={!submitBtnStatus ? `greenBtn` : "disbledBtn"}
                onClick={() => setReviewModalVisible(true)}
                type="primary"
                htmlType="submit"
              >
                Review & Submit
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className="data-loader">
          <Spin tip="Loading" size="large" />
        </div>
      )}
      <Modal
        width={450}
        style={{ top: "30vh" }}
        open={alertModal}
        onCancel={() => setAlertModal(false)}
        footer={null}
        closable={false}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <h3>Please use a laptop or a desktop to login</h3>
        </div>
      </Modal>
      <Modal open={isModalOpen} footer={null} width={320} onCancel={HideModal}>
        <p className="signup-text">
          Thank you for signing up and once approved please check your email for
          your login details &#40; also check your spam folder &#41;
        </p>
      </Modal>
      <Modal open={deniedModal} footer={null} width={320} onCancel={HideModal}>
        <p className="signup-text">
          Sorry, Organisation name already exists
        </p>
      </Modal>
      <Modal
        open={reviewModalVisible}
        onCancel={handleCancel}
        footer={null}
        // closable={false}
        className="viewMicrositeModal"
        style={{ marginTop: "45px" }}
      >
        <div className="approve-container">

          <div className="ReviewInfoPopUp">
            <h2>Review your Information</h2>
            <div className="ReviewInfoRow">
              <div className="ReviewInfoCol">Organisation type</div>
              <div className="ReviewInfoCol">{state?.nameType}</div>
            </div>
            {
              state?.formData?.salesType  !== "retail"  && (
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol">{EXISTING_MEMBER_QUESTIONS[partnerData?.partnerType?.toLowerCase()] ||  "Are you an existing member?"}</div>
                <div className="ReviewInfoCol">{state?.formData?.isActiveMember === true ? "Yes" : "No"}</div>
              </div>
            )}
            <div className="ReviewInfoRow">
              <div className="ReviewInfoCol">Organisation name</div>
              <div className="ReviewInfoCol">{state?.formData?.name}</div>
            </div>
            <div className="ReviewInfoRow">
              <div className="ReviewInfoCol">Address</div>
              <div className="ReviewInfoCol">{state?.formData?.addressStreet}</div>
            </div>
            <div className="ReviewInfoRow">
              <div className="ReviewInfoCol">Postal code</div>
              <div className="ReviewInfoCol">{state?.formData?.postcode}</div>
            </div>
            <div className="ReviewInfoRow">
              <div className="ReviewInfoCol">Organisation size</div>
              <div className="ReviewInfoCol">{state?.formData?.size === "MICRO" ? "Micro 0-9"
                : state?.formData?.size === "SMALL" ? "Small 10-49"
                  : state?.formData?.size === "MEDIUM" ? "Medium 50-249"
                    : state?.formData?.size === "LARGE" ? "Large 249+"
                      : ""}</div>
            </div>
            <div className="ReviewInfoRow">
              <div className="ReviewInfoCol">Full name</div>
              <div className="ReviewInfoCol">{state?.formData?.userName}</div>
            </div>
            <div className="ReviewInfoRow">
              <div className="ReviewInfoCol">Email</div>
              <div className="ReviewInfoCol">{state?.formData?.email}</div>
            </div>
            <div className="ReviewInfoRow">
              <div className="ReviewInfoCol">Phone number</div>
              <div className="ReviewInfoCol">{state?.formData?.phone}</div>
            </div>
            <div className="ReviewInfoRow">
              <div className="ReviewInfoCol">Organisation website</div>
              <div className="ReviewInfoCol">{state?.formData?.websiteLink}</div>
            </div>
            <div className="ReviewInfoRow">
              <div className="ReviewInfoCol"></div>
              <div className="ReviewInfoCol">
                <Button
                  onClick={() => navigate("/signup")}
                  // type="primary"
                  // htmlType="submit"
                  className="editbtn"
                >
                  Edit
                </Button>
                <Button
                  onClick={() => submitHandler()}
                  type="primary"
                  htmlType="submit"
                  className="greenBtn"
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
